import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { useDonations } from '../../../Hooks/useDonations'
import Form from './Form'
import DonationHistory from './DonationHistory'

function Donations() {
  const {
    donations,
    isLoading,
    donationRate,
    setDonationRate,
    isParticipating,
    setIsParticipating,
    handleConfirmDonationRate,
    handleCancel,
  } = useDonations()

  const columnsConfig = {
    id: { visible: false },
    organization: { title: 'Organization' },
    date: { title: 'Date' },
    donationRate: { title: 'Donation Rate' },
    action: { title: 'Action' },
  }

  return (
    <div>
      <Form
        donationRate={donationRate}
        setDonationRate={setDonationRate}
        handleConfirmDonationRate={handleConfirmDonationRate}
        isParticipating={isParticipating}
        setIsParticipating={setIsParticipating}
      />

      <DonationHistory
        donations={donations}
        isLoading={isLoading}
        columnsConfig={columnsConfig}
      />

      <div className="sales-form__action-buttons-container">
        <Button size="small" onClick={handleConfirmDonationRate} type="primary">
          Save changes
        </Button>
        <Button size="small" onClick={handleCancel} type="secondary">
          Cancel
        </Button>
      </div>
    </div>
  )
}

export default Donations
